import { Component, OnInit, Input } from '@angular/core';
import { Category } from 'src/app/models/category';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-category-tile',
  templateUrl: './category-tile.component.html',
  styleUrls: ['./category-tile.component.scss']
})
export class CategoryTileComponent implements OnInit {
  @Input('category') category;
  @Input('inSlider') inSlider;
  public categoryImagePath:string;
  constructor() {

    this.categoryImagePath=environment.apiEndpoint+'/storage/categories/';
  }

  ngOnInit() {
    if(this.category.media.url=='/assets/imgs/default-icon.png') this.category.media.url='default-icon.png';
  }

}
